export enum DisciplineEnum {
  SkilledNursing = 1,
  PhysicalTherapy = 2,
  SpeechTherapy = 3,
  OccupationalTherapy = 4,
  MedicalSocialWorker = 5,
  HomeHealthAide = 6
}

export const DisciplineOptions = [
{ id: 1, label: 'Skilled Nursing', abbreviation: 'SN' },
{ id: 2, label: 'Physical Therapy', abbreviation: 'PT' },
{ id: 3, label: 'Speech Therapy', abbreviation: 'ST' },
{ id: 4, label: 'Occupational Therapy', abbreviation: 'OT' },
{ id: 5, label: 'Medical Social Work', abbreviation: 'MSW' },
{ id: 6, label: 'Home Health Aide', abbreviation: 'HHA' }
];
